// Function to set a cookie with a default expiration of 1 day
function setCookie(name, value, days = 1) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
// Function to remove a specific cookie on both current and parent domain
function removeCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    const parts = window.location.hostname.split(".");
    if (parts.length > 2) {
        const parentDomain = "." + parts.slice(1).join(".");
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + parentDomain + ';';
    }
}
  
  // Function to clear all cookies on both the current domain and the parent domain
function clearAllCookies() {
    const cookies = document.cookie.split(";");
    const hostname = window.location.hostname;
    // Derive parent domain (e.g. ".peerception.io" from "app.peerception.io")
    const parts = hostname.split(".");
    const parentDomain = parts.length > 2 ? "." + parts.slice(1).join(".") : "";

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        // Clear on current domain (no domain attribute)
        document.cookie = name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";
        // Clear on parent domain (e.g. .peerception.io) to remove SSO-set cookies
        if (parentDomain) {
            document.cookie = name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + parentDomain + ";";
        }
    }
}

export {
    setCookie,
    getCookie,
    removeCookie,
    clearAllCookies,
}